import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_MODAL } from '../../../../constants/things.constants';

@Component({
  selector: 'delete-group-selector',
  templateUrl: './deleteGroup.component.html',
  styleUrls: ['./deleteGroup.component.less'],
})
export class DeletGroupComponent  {

  @Input()
  public groupName: string = '';

  public constructor(public activeModal: NgbActiveModal) {

  }

  discard() {
    this.activeModal.close(false);
  }

  submit() {
    this.activeModal.close(this.groupName);
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/restroomGroup/delete/deleteGroup.component.ts